<div class="zn-form" [formGroup]="form">
  <fieldset>
    <div class="row">
      <div class="col-12">
        <div class="form-control-container mb-2">
          <label class="form-label" for="MeditionNumber">
            {{ measurementLabelKey | abpLocalization }}
            <span class="form-label-required">*</span>
          </label>
          <zn-single-select
            id="MeditionNumber"
            [optionsLoader]="meditionNumbers"
            [showSearch]="true"
            formControlName="MeditionNumber"
            [errorEntityKey]="measurementLabelKey"
            [localizationResource]="localizationResource"
            [openUp]="false"
          ></zn-single-select>
        </div>
      </div>

      <div class="col-12">
        <div class="form-control-container">
          <label class="form-label" for="StandNumbers">
            {{ standLabelKey | abpLocalization }}
            <span class="form-label-required">*</span>
          </label>
          <zn-multi-select
            #standSelect
            id="StandNumbers"
            [options]="standOptions()"
            [showSearch]="true"
            [deferSelection]="false"
            formControlName="StandNumbers"
            [errorEntityKey]="standLabelKey"
            [localizationResource]="localizationResource"
            [openUp]="false"
            (selectedChange)="onStandSelectionChange($event)"
          ></zn-multi-select>
        </div>
      </div>
    </div>
  </fieldset>
</div>
